module.exports = "<div ng-class=\"{'<%= gwWizardTileLabelDefault %>': currentFlavor === 'Default',\r\n                '<%= gwWizardTileLabelSmall %>': currentFlavor === 'Small',\r\n                '<%= gwWizardTileLabelActive %>': state() == 'active'}\">\r\n    <ng-transclude></ng-transclude>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/tiles/tileLayout/Label/tile-label.html
// module id = 602
// module chunks = 0